import { useMemo } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  useGetPolicyLazyQuery,
  useOnCreatePolicyNoteSubscription,
} from "@covertree/agent-portal-graphql";

import { PolicyDetailsContentProps } from "../../../../types";
import { NotesLoading } from "./NotesLoading";
import { NewNoteForm } from "./NewNoteForm";
import { NotesError } from "./NotesError";
import { NotesList } from "./NotesList";

export function PolicyNotes({
  policy,
  loading,
  error,
}: PolicyDetailsContentProps) {
  const [
    getPolicy,
    { loading: isPolicyRefreshing, error: policyRefreshingError },
  ] = useGetPolicyLazyQuery({
    variables: { policyLocator: policy?.policyLocator },
  });

  const { data: updatedPolicy } = useOnCreatePolicyNoteSubscription({
    variables: { policyLocator: policy?.policyLocator },
    skip: !policy,
  });

  const isLoading = useMemo(
    () => loading || isPolicyRefreshing,
    [loading, isPolicyRefreshing]
  );

  const isError = useMemo(
    () => error || !!policyRefreshingError,
    [error, policyRefreshingError]
  );

  return (
    <Grid padding={3} item xs={12} container spacing={1}>
      <Grid item xs={12}>
        <Typography gutterBottom>Notes</Typography>
      </Grid>

      <Grid item xs={12} container>
        {!policy && isLoading ? (
          <NotesLoading />
        ) : isError ? (
          <NotesError
            disabled={loading || isPolicyRefreshing}
            refetch={getPolicy}
          />
        ) : (
          <NotesList
            notes={updatedPolicy?.onCreatePolicyNote?.notes || policy.notes}
          />
        )}
      </Grid>

      <Grid item xs={12}>
        <NewNoteForm
          policyLocator={policy?.policyLocator}
          loading={isLoading}
        />
      </Grid>
    </Grid>
  );
}
